
/**
 * Backend under construction.
 * 
 * This is a learning implementation of MicroServices Architecture
 * 
 */
const ChatApi = {

    helloWorld: () => "hello world!"

}

export default ChatApi;